import { useMemo, useCallback } from "react";
import { useNavigationAccessContext } from "../contexts/NavigationAccessContext";
import { filterNavItems } from "./navAccess";

/**
 * Hook to access navigation permissions. 
 * Now consumes from NavigationAccessContext for app-wide consistency.
 */
export function useNavigationAccess() {
  const { 
    featuresLoading, 
    hasPermission, 
    subscribedModules, 
    navAppScopeActive, 
    navAppAllowedKeys,
    refreshAccess 
  } = useNavigationAccessContext();

  const ctx = useMemo(() => ({
    hasPermission,
    navAppScopeActive,
    navAppAllowedKeys,
    subscribedModules,
  }), [hasPermission, navAppScopeActive, navAppAllowedKeys, subscribedModules]);

  const filterItems = useCallback(
    (items) => filterNavItems(items, ctx),
    [ctx]
  );

  return {
    featuresLoading,
    hasPermission,
    filterItems,
    ctx,
    refreshNav: refreshAccess
  };
}
